import { render, staticRenderFns } from "./swTop.vue?vue&type=template&id=4f0bdca2&scoped=true&"
import script from "./swTop.vue?vue&type=script&lang=ts&"
export * from "./swTop.vue?vue&type=script&lang=ts&"
import style0 from "./swTop.vue?vue&type=style&index=0&id=4f0bdca2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0bdca2",
  null
  
)

export default component.exports